
// class TitleMove{
//   $mobileWrap = document.getElementById('moblile_title_wrap');
//   $pcWrap = document.getElementById('pc_title_wrap');
//   MQL = window.matchMedia('(max-width: 999px)')
//   constructor(){ this.init() }
//   init(){
//     if( !this.MQL.matches){
//       this.pcTitle()
//     }
//     this.MQL.addEventListener("change", ()=>{
//       if( this.MQL.matches){
//         this.mobileTitle()
//       }else{
//         this.pcTitle()
//       }
//     })
//   }
//   pcTitle(){
//     if( this.$mobileWrap && this.$pcWrap){
//       const $title = this.$mobileWrap.querySelector('#product_title');
//       if(!$title) return;
//       this.$pcWrap.appendChild($title)
//     }
//   }
//   mobileTitle(){
//     if( this.$mobileWrap && this.$pcWrap){
//       const $title = this.$pcWrap.querySelector('#product_title');
//       if(!$title) return;
//       this.$mobileWrap.appendChild($title)
//     }
//   }
// }
// document.addEventListener('DOMContentLoaded', ()=>{
//   new TitleMove()
// })
document.addEventListener('DOMContentLoaded', ()=>{
  const $title = document.getElementById('product_title');
  if( !$title || $title === undefined) return;
  const _height = $title.offsetHeight;
  document.documentElement.style.setProperty('--product-title-height', `${_height}px`);
})